import { render, staticRenderFns } from "./LoginAuto.vue?vue&type=template&id=fb42c258&scoped=true&"
import script from "./LoginAuto.vue?vue&type=script&lang=js&"
export * from "./LoginAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb42c258",
  null
  
)

export default component.exports